import React from "react";
import { View } from "react-native";
import Text from "theme/Text";
import { colorList } from "utils/colors";
import { TagStyles } from 'styles/components/atoms/Tag'
import ThemedPressable from 'components/atoms/ThemedPressable'
import isEqual from 'react-fast-compare'


const Color = require('color');

export const tagAppearances = {
	BLUE: 'blue',
	RED: 'red',
	GREEN: 'green',
	ORANGE: 'orange',
	YELLOW: 'YELLOW',
	PURPLE: 'PURPLE',
	GREY: 'GREY',
	CUSTOM: 'CUSTOM'
}

const Tag = ({ appearance = tagAppearances.BLUE, color, style = {}, onPress, children }) => {
	
	const setColor = ( primary, border ) => {
		return {
			backgroundColor: primary,
			borderColor: border
		}
	}
	
	let viewStyle = {};
	let textStyle = TagStyles.text_light;

	switch( appearance ) {
		case tagAppearances.BLUE:
			viewStyle = setColor( colorList.BLUE.primary, colorList.BLUE.dark );
			break;
			
		case tagAppearances.RED:
			viewStyle = setColor( colorList.RED.primary, colorList.RED.dark );
			break;
			
		case tagAppearances.GREEN:
			viewStyle = setColor( colorList.GREEN.primary, colorList.GREEN.dark );
			break;
			
		case tagAppearances.ORANGE:
			viewStyle = setColor( colorList.ORANGE.primary, colorList.ORANGE.dark );
			break;
			
		case tagAppearances.PURPLE:
			viewStyle = setColor( colorList.PURPLE.primary, colorList.PURPLE.dark );
			break;

		case tagAppearances.GREY:
			viewStyle = setColor( colorList.GREY.primary, colorList.GREY.dark );
			textStyle = TagStyles.text_dark;
			break;
		
		case tagAppearances.CUSTOM:
			viewStyle = setColor( color, Color( color ).darken( 0.2 ) )
	}
	
	const viewInnerStyle = [
		TagStyles.container,
		style,
		viewStyle
	]

	let view = (
		<View
			style={ viewInnerStyle }>

			<Text
				style={ [ textStyle ] }
				category={"c2"}>
				
				{ children }
			</Text>
		</View>
	);

	if( onPress ) {
		view = (
			<ThemedPressable
				onPress={ onPress }>
				
				{ view }
			</ThemedPressable>
		);
	}

	return view;
}

export default React.memo( Tag, isEqual );
